import {
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    useDisclosure
} from '@chakra-ui/react'
import GroupItem from '../../Groups/GroupItem'
import usePrintSalesByWaiter from '../../hooks/usePrintSalesByWaiter'
import ContentForm from './ContentForm'

export default function ModalSalesByWaiters() {
    const { isLoading, submit } = usePrintSalesByWaiter()
    const { isOpen, onClose, onOpen } = useDisclosure()

    return (
        <>
            <GroupItem onClick={onOpen} label="Ventas por Meser@" />
            <Modal isOpen={isOpen} onClose={onClose} size="sm">
                <ModalOverlay />
                <ModalContent p={4} pb={6}>
                    <ModalHeader textAlign="center">
                        Reporte de Ventas por Meser@
                    </ModalHeader>
                    <ModalBody>
                        <ContentForm onSubmit={submit} isLoading={isLoading} />
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}
